import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import * as objectPath from 'object-path';
import { LayoutConfigService } from "../layout-config.service";
import { MenuService } from '../http_services/genel/menu.service';
import { ProgressSpinnerService } from '../../_shared/progress-spinner/progress-spinner.service';
import { MenuConfigService } from '../menu-config.service';
import { AktifKullaniciBilgisiService } from '@core/auth/aktif-kullanici-bilgisi.service';
import { YetkiInfo } from '@core/auth/YetkiInfo';
import { AppConsts } from '@core/genel/AppConsts';
import { CustomerService } from '../customer.service';
import { environment } from '@environments/environment';
import { LoginTipleri } from '@core/genel/AppEnums';

@Injectable()
export class MenuAsideService {
	classes: string;
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject([]);

	isDropdown: number = 0;
	dropdownTimeout: number;
	isScrollable: number = 0;
	YetkiInfo: YetkiInfo[] = [];
	eDonusum = false;
	onMuhasebe = false;

	sefFaturaDisabledMenus = ['Tahsilatlarım', 'Manuel Tahsilat Oluştur', 'BA/BS Raporu', 'Kontor Raporu', 'Kep Alici Listesi', 'Kep Gönderici Listesi', 'Sıkça Sorulan Sorular',
		'Uzaktan Bağlantı Desteği', 'İnternet Satış Bilgileri', 'Satın Alma İşlemi', 'Kullanım Çizelgesi', 'Yolcu Listesi', 'Etkinlik Ebilet Listesi', 'Müstahsil Oluşturma',
		'Müstahsil Makbuzlar', 'Giden Kepler', 'Gelen Kepler','Kullanıcı İşlemleri']

	sefMakbuzDisabledMenus = ['Yolcu Listesi', 'Etkinlik Ebilet Listesi','Satın Alma İşlemi', 'Kullanım Çizelgesi', 'Sıkça Sorulan Sorular','Uzaktan Bağlantı Desteği',
	'Tahsilatlarım', 'Manuel Tahsilat Oluştur','Kullanıcı İşlemleri']

	turkFaturaDisabledMenus = ['Veri Al Gönder','Ürün Aktar','Cari Aktar']


	constructor(
		private layoutConfigService: LayoutConfigService,
		private httpMenuService: MenuService,
		private progressSpinnerService: ProgressSpinnerService,
		private menuConfigService: MenuConfigService,
		private aktifKullaniciService: AktifKullaniciBilgisiService,
		private customerService: CustomerService
	) {

		this.YetkiInfo = this.aktifKullaniciService.aktifKullaniciBilgisi.KLNC_YETKI_INFO;
		if (this.YetkiInfo.find(i => i.KONTROL_NOKTASI_ADI == AppConsts.kontrolNoktalari.onMuhasebe))
			this.onMuhasebe = true;
		if (this.YetkiInfo.find(i => i.KONTROL_NOKTASI_ADI == AppConsts.kontrolNoktalari.arsivIslemleri || i.KONTROL_NOKTASI_ADI == AppConsts.kontrolNoktalari.faturaIslemleri
			|| i.KONTROL_NOKTASI_ADI == AppConsts.kontrolNoktalari.makbuzIslemleri || i.KONTROL_NOKTASI_ADI == AppConsts.kontrolNoktalari.irsaliyeIslemleri))
			this.eDonusum = true;

		//this.menuleriGetir();

		this.menuConfigService.onMenuUpdated$.subscribe(model => {
			const kullaniciMenuleri: any[] = [];
			const tumMenuler = objectPath.get(model.config, 'aside.items');

			for (let menuIndex = 0; menuIndex < tumMenuler.length; menuIndex++) {
				const menu = tumMenuler[menuIndex];
				if (this.aktifKullaniciService.yetkisiVarMi(menu.KONTROL_NOKTASI_ADI)) {
					kullaniciMenuleri.push(menu);
					if (menu.submenu != null && menu.submenu.length > 0) {
						for (let subMenuIndex = 0; subMenuIndex < menu.submenu.length; subMenuIndex++) {
							const subMenu = menu.submenu[subMenuIndex];
							if (this.aktifKullaniciService.yetkisiVarMi(subMenu.KONTROL_NOKTASI_ADI)) {
								menu.push(subMenu);
								break;
							}
						}
					}
				}
			}

			//this.menuList$.next(kullaniciMenuleri)
			//this.menuleriGetir();
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(config => {
			if (objectPath.get(config, 'config.aside.left.fixed')) {
				this.isScrollable = 1;
				this.isDropdown = 0;
			}

			if (!objectPath.get(config, 'config.aside.left.fixed') && !objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.accordion')) {
				this.isScrollable = 0;
				this.isDropdown = 1;
				this.dropdownTimeout = objectPath.get(config, 'config.menu.aside.desktop_and_mobile.submenu.dropdown.hover_timeout');
			}
		});
	}


	menuleriGetir() {
		this.progressSpinnerService.show();
		this.httpMenuService.getMenuler().subscribe(
			data => {
				//data = this.menuleriAyarla(data, this.eDonusum, this.onMuhasebe);
				data = this.sectionlariAyarla(data);
				this.menuList$.next(data);
				this.progressSpinnerService.hide();
			},
			() =>
				this.progressSpinnerService.hide(),
			() =>
				this.progressSpinnerService.hide()
		)
	}

	sectionlariAyarla(liste: any[]) {

		if (this.customerService.settings.name == "sef") {
			if (environment.LOGIN_TIPI == LoginTipleri.turkFatura) {
				for (let i = liste.length - 1; i >= 0; i--) {
					if (this.sefFaturaDisabledMenus.includes(liste[i].MENU_ADI)) {
						liste.splice(i, 1)
					}
				}
			}
			else if (environment.LOGIN_TIPI == LoginTipleri.turkMakbuz) {

				for (let i = liste.length - 1; i >= 0; i--) {
					if (this.sefMakbuzDisabledMenus.includes(liste[i].MENU_ADI)) {
						liste.splice(i, 1)
					}
				}
			}
		}
		else{
			for (let i = liste.length - 1; i >= 0; i--) {
				if (this.turkFaturaDisabledMenus.includes(liste[i].MENU_ADI)) {
					liste.splice(i, 1)
				}
			}
		}

		let rozetler: any[] = liste.filter(s => s.ROZETDEGERI != null);
		for (let rozetIndex = 0; rozetIndex < rozetler.length; rozetIndex++) {
			const rozet = rozetler[rozetIndex];
			for (let listeIndex = 0; listeIndex < liste.length; listeIndex++) {
				const menu = liste[listeIndex];
				if (rozet.ROZETDEGERI == menu.ROZETDEGERI) {
					let section: any = { section: rozet.ROZETDEGERI };
					liste.splice(listeIndex, 0, section);
					break;
				}
			}
		}
		return liste;
	}

	// menuleriAyarla(liste: MenuInfo[], eDonusum: boolean, onMuhasebe: boolean) {
	// 	if (eDonusum && onMuhasebe) {
	// 		liste = liste.filter(t => t.KONTROL_NOKTASI_ADI != AppConsts.onMuhasebe);
	// 	} else if (!eDonusum && onMuhasebe) {
	// 		liste = liste.filter(t => t.KONTROL_NOKTASI_ADI == AppConsts.onMuhasebe);
	// 	}
	// 	return liste;
	// }
}
